<template>
  <v-container fluid>
    <v-layout row>
      <v-flex xs6 sm6 md6 lg8 order-md1>
        <v-card>
<!--            <div class="google-map" id='map'/> -->
          <gmap-map
          ref='map'
          :center="center"
          :zoom="zoom"
          :options= "options"
          style="width: 100%; height: 500px"
          >
        </gmap-map>

      </v-card>
    </v-flex>
    <v-flex xs6 sm6 md6 lg8 order-md2>
      <v-card>
        <v-flex xs12 sm6 class="py-2">
            <p>Layer Select</p>
            <v-btn-toggle v-model="layerSelect">
              <v-btn flat value="fedland">
                Federal Land
              </v-btn>
              <v-btn flat value="nm_allot">
                NM Allot
              </v-btn>
              <v-btn flat value="landGrands">
                Land Grants
              </v-btn>
            </v-btn-toggle>
          </v-flex>
          <v-flex xs12 sm6 class="py-2">
            <v-progress-linear v-bind:active='!layerReady' :indeterminate='true'>
            </v-progress-linear>
          </v-flex>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>
<script>
  import Vue from 'vue'
  import * as VueGoogleMaps from 'vue2-google-maps'
  import {db} from '../../firebase/firebase'
  import proj4 from 'proj4'
  import reproject from 'reproject'

  Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyCrDutt_d5HwiSO8pwRfvdtC2TSI87PMIg',
      v: '3.exp'
    }
  })
  export default {
    data () {
      return {
        layerSelect: 'fedland',
        wellMapId: '',
        zoom: 4,
  //       /* eslint-disable */
  //       layer2: {
  //         "type": "FeatureCollection",
  //         "features": [
  //           {
  //             "type": "Feature",
  //             "geometry": {
  //             "type": "Polygon",
  //             "coordinates": [
  //               [
  //                 [
  //                   -107.36737909416217,
  //                   35.950857392796834
  //                 ],
  //                 [
  //                   -104.51093378166217,
  //                   36.164016695639894
  //                 ],
  //                 [
  //                   -104.29120721916217,
  //                    33.16465684199344
  //                 ],
  //                 [
  //                   -107.30146112541217,
  //                    33.27494746223384
  //                 ],
  //                 [
  //                   -107.36737909416217,
  //                   35.950857392796834
  //                 ]
  //               ]
  //           ]
  //       },
  //       "properties": {}
  //   }
  // ]
  //         /* eslint-enable */
  //       },
        mapReady: false,
        layerReady: false,
        projectedLayer: {},
        center: {lat: 34.5199, lng: -105.8701},
        paths: [],
        options: {styles: [
          {elementType: 'geometry', stylers: [{color: '#ebe3cd'}]},
          {elementType: 'labels.text.fill', stylers: [{color: '#523735'}]},
          {elementType: 'labels.text.stroke', stylers: [{color: '#f5f1e6'}]},
          {
            featureType: 'administrative',
            elementType: 'geometry.stroke',
            stylers: [{color: '#c9b2a6'}]
          },
          {
            featureType: 'administrative.land_parcel',
            elementType: 'geometry.stroke',
            stylers: [{color: '#dcd2be'}]
          },
          {
            featureType: 'administrative.land_parcel',
            elementType: 'labels.text.fill',
            stylers: [{color: '#ae9e90'}]
          },
          {
            featureType: 'landscape.natural',
            elementType: 'geometry',
            stylers: [{color: '#dfd2ae'}]
          },
          {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [{color: '#dfd2ae'}]
          },
          {
            featureType: 'poi',
            elementType: 'labels.text.fill',
            stylers: [{color: '#93817c'}]
          },
          {
            featureType: 'poi.park',
            elementType: 'geometry.fill',
            stylers: [{color: '#a5b076'}]
          },
          {
            featureType: 'poi.park',
            elementType: 'labels.text.fill',
            stylers: [{color: '#447530'}]
          },
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [{color: '#f5f1e6'}]
          },
          {
            featureType: 'road.arterial',
            elementType: 'geometry',
            stylers: [{color: '#fdfcf8'}]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [{color: '#f8c967'}]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [{color: '#e9bc62'}]
          },
          {
            featureType: 'road.highway.controlled_access',
            elementType: 'geometry',
            stylers: [{color: '#e98d58'}]
          },
          {
            featureType: 'road.highway.controlled_access',
            elementType: 'geometry.stroke',
            stylers: [{color: '#db8555'}]
          },
          {
            featureType: 'road.local',
            elementType: 'labels.text.fill',
            stylers: [{color: '#806b63'}]
          },
          {
            featureType: 'transit.line',
            elementType: 'geometry',
            stylers: [{color: '#dfd2ae'}]
          },
          {
            featureType: 'transit.line',
            elementType: 'labels.text.fill',
            stylers: [{color: '#8f7d77'}]
          },
          {
            featureType: 'transit.line',
            elementType: 'labels.text.stroke',
            stylers: [{color: '#ebe3cd'}]
          },
          {
            featureType: 'transit.station',
            elementType: 'geometry',
            stylers: [{color: '#dfd2ae'}]
          },
          {
            featureType: 'water',
            elementType: 'geometry.fill',
            stylers: [{color: '#b9d3c2'}]
          },
          {
            featureType: 'water',
            elementType: 'labels.text.fill',
            stylers: [{color: '#92998d'}]
          }
        ] }
      }
    },
    // mounted: function () {
    //   const element = document.getElementById('map')
    //   console.log(element)
    //   const options = {
    //     zoom: this.zoom,
    //     center: new google.maps.LatLng(this.center.lat, this.center.lng) // eslint-disable-line no-undef
    //   }
    //   const map = new google.maps.Map(element, options) // eslint-disable-line no-undef
    //   map.data.addGeoJson(this.layer)
    //   map.data.setStyle({
    //     strokeColor: 'red',
    //     strokeWeight: 10
    //   })
    // },
    mixins: [VueGoogleMaps.MapElementMixin],
    watch: {
      mapReady: function () {
        if (this.layerReady) {
          this.setLayer()
        }
      },
      layerReady: function () {
        if (this.mapReady) {
          this.setLayer()
        }
      },
      layerSelect: function () {
        this.layerReady = false
        var map = this.$refs.map.$mapObject
        map.data.forEach(function (feature) {
          map.data.remove(feature)
        })
        this.$unbind('layer')
        this.$bindAsObject('layer', db.ref('/projects/Valencia/data/layers/' + this.layerSelect), null, () => {
          this.layerReady = true
          this.setLayer()
        })
      }
    },
    methods: {
      setLayer: function () {
        // this.transform()
        var map = this.$refs.map.$mapObject
        map.data.addGeoJson(this.layer)
        map.data.setStyle({
          strokeColor: 'red',
          strokeWeight: 1
        })
      },
      setUpMap: function () {
        this.center.lat = 0.0
        this.center.lng = 0.0
        this.zoom = 5
      },
      transform: function () {
        proj4.defs('google', '+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs')
        proj4.defs('nmnat83', '+proj=utm +zone=14 +ellps=clrk66 +x_0=5000000 +datum=NAD27 +units=m +no_defs')
        let googleProject = proj4('google')
        let utmProject = proj4('nmnat83')
        this.projectedLayer = reproject.reproject(this.layer, 'utmProject', 'googleProject', {'utmProject': utmProject, 'googleProject': googleProject})
      }
    },
    deferredReady: function () {
      this.$refs.map.$mapCreated.then(() => {
        // layer.setMap(this.$refs.map.$mapObject)
        // this.layer = layer
        this.mapReady = true
      })
    },
    firebase: function () {
      return {
        layer: {
          source: db.ref('/projects/Valencia/data/layers/fedland'),
          asObject: true,
          readyCallback: function () {
            this.layerReady = true
          }
        }
      }
    }
  }
</script>
<style scoped>
.google-map {
  width: 800px;
  height: 600px;
  margin: 0 auto;
  background: gray;
}
</style>


// WEBPACK FOOTER //
// src/components/map/LayerMap.vue